import type { Archive } from "../domain/types";
import { saveArchive } from "./db";
export class ArchivePersistenceCoordinator {
  private queue = new Map<
    string,
    {
      archive: Archive;
      resolvers: Array<{
        resolve: () => void;
        reject: (error: unknown) => void;
      }>;
    }
  >();
  private running = false;
  enqueue(archive: Archive) {
    return new Promise<void>((resolve, reject) => {
      const current = this.queue.get(archive.archiveId);
      if (current) {
        current.archive = structuredClone(archive);
        current.resolvers.push({ resolve, reject });
      } else
        this.queue.set(archive.archiveId, {
          archive: structuredClone(archive),
          resolvers: [{ resolve, reject }],
        });
      void this.flush();
    });
  }
  private async flush() {
    if (this.running) return;
    this.running = true;
    try {
      while (this.queue.size) {
        const [name, job] = this.queue.entries().next().value as [
          string,
          {
            archive: Archive;
            resolvers: Array<{
              resolve: () => void;
              reject: (error: unknown) => void;
            }>;
          },
        ];
        this.queue.delete(name);
        try {
          await saveArchive(job.archive);
          job.resolvers.forEach((item) => item.resolve());
        } catch (error) {
          job.resolvers.forEach((item) => item.reject(error));
        }
      }
    } finally {
      this.running = false;
    }
  }
}
export const archivePersistenceCoordinator =
  new ArchivePersistenceCoordinator();
